export enum Position {
  Center = 'center',
  Bottom = 'bottom',
};